module.exports = __webpack_public_path__ + "img/people-in-cafe.48789b7f.jpg";